// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"bfd26eb8","583":"828b2230"}[chunkId] + ".chunk.js";
};